import { ChangeDetectorRef, Component } from '@angular/core';
import { AProgessBarWizardComponent } from '../../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { TranslateHelper } from '../../../helpers/injector.helper';
import { SmartSyncService } from '../../../services/smart.sync.service';

@Component({
    selector: 'siw-filter-page',
    templateUrl: './siw.filter.page.html',
    styleUrls: ['./siw.filter.page.css']
})
export class SmartIntegrationWizardFilterPage extends AProgessBarWizardComponent {
    OptionalFilterFields = [];
    MandatoryFilterFields = [];

    constructor(private cdRef: ChangeDetectorRef, private service: SmartSyncService) {
        super();
    }

    OnWizardStateSet(): void {
        if (this.WizardState) {
            if (this.WizardState.SelectedUseCase && this.WizardState.LoadedUseCases) {
                const useCase = this.WizardState.LoadedUseCases[this.WizardState.SelectedUseCase.ID];
                if (useCase && useCase.Tables) {
                    const disabledText = TranslateHelper.TranslatorInstance.instant('@@Loading');
                    useCase.Tables.forEach((t: any) => {
                        if (t && t.Fields) {
                            t.Fields.forEach((f: any) => {
                                if (f.CanBeFiltered) {
                                    if (!f.FilterValue) {
                                        f.FilterValue = {
                                            Values: [],
                                            Options: [{
                                                Caption: disabledText,
                                                Disabled: true
                                            }],
                                            OptionsQuery: {
                                                DataSource: this.WizardState.SelectedDataSource.Id,
                                                TableName: t.Name,
                                                Schema: t.Schema,
                                                Field: f.Name
                                            }
                                        };
                                    }
                                    if (f.MustBeFiltered) {
                                        this.MandatoryFilterFields.push(f);
                                    } else {
                                        this.OptionalFilterFields.push(f);
                                    }
                                }
                            });
                        }
                    });
                    this.checkCanStepForward();
                }
            }
        }
    }

    checkCanStepForward() {
        this.CanStepForwardValue = this.MandatoryFilterFields.length == 0 ||
            !this.MandatoryFilterFields.some((x: any) => {
                if (x.FilterValue == null) {
                    return true;
                } else {
                    if (x.DataTyp == "System.DateTime") {
                        return x.FilterValue.From == null && x.FilterValue.To == null;
                    } else {
                        return x.FilterValue.Values.length == 0;
                    }
                }
            });
        this.cdRef.detectChanges();
    }

    fillOptions(mf: any) {
        if (mf.FilterValue && mf.FilterValue.OptionsQuery) {
            this.service.GetFieldValues(mf.FilterValue.OptionsQuery).subscribe(x => {
                const options = [];
                if (x) {
                    x.forEach((y: any) => {
                        options.push({
                            Caption: '' + y,
                            Value: y,
                            Disabled: false
                        });
                    });
                }
                mf.FilterValue.Options = options;
                this.cdRef.detectChanges();
            });
            mf.FilterValue.OptionsQuery = null;
        }
    }
}
